module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Safestore - Norbiton",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--safestore-norbiton.netlify.app/' : 'https://safestorenorbiton.co.uk/',

    holding: {
        "brand": "/assets/images/logo-yellow.svg",
        "message": "Plans for a new Safestore in Norbiton"
    },

    base: {
        "contact_address": "",
        "contact_number": "020 7323 3544",
        "contact_email": "safestore@camargue.uk"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "",
        "description": "",
        "gtag": "G-RG1TFFMCK5",
        "gtm": "GTM-WZ2F4ZTB"
    },

    form: {
        "contact": {
            "catcher_id": "3d3fb2b56b395eb9c9254667e85a7727",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "0c3855e67c5f2812113c8633f012c4b9"
        },
        "feedback": {
            "catcher_id": "3d3fb2b56b395eb9c9254667e85a7727",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "0c3855e67c5f2812113c8633f012c4b9"
        }
    },

    consultation: {
        "feedback_active": false,
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation is closed and is no longer accepting feedback.",

        // Consultation close countdown. If set to true, show countdown in site header
        "has_countdown": false,
        "countdown_end": "03/31/2022 23:59:59", // Date format MM/DD/YYYY HH:MM:SS

        "themes": [
            {
                "name": "Our proposals",
                "url": "section-1",
                "feedback_url": '',
                "icon": "design",
                "question": "Do you have any comments on the overall principles of the proposed development?",
                "key": "01-section"
            },
            {
                "name": "Improvements",
                "url": "section-2",
                "feedback_url": 'page-2/',
                "icon": "tick",
                "question": "We're looking at how best we can improve the local street scene. Do you have any further ideas on landscaping, greenery and improvements to pedestrian areas?",
                "key": "02-section"
            },
            {
                "name": "Other comments",
                "url": "section-3",
                "feedback_url": 'page-3/',
                "icon": "question",
                "question": "Do you have any other comments?",
                "key": "03-section"
            },
            {
                "name": "About you",
                "url": "section-4",
                "feedback_url": 'page-4',
                "icon": "person",
                "questions": [
                    {
                        "number": 4,
                        "question": "Are you a local resident or business owner?",
                        "type": "checkbox",
                        "options": [
                            { "label": "Resident" },
                            { "label": "Business owner" },
                            { "label": "Other (please specify)" }
                        ]
                    },
                    {
                        "number": 5,
                        "question": "Are you a Safestore customer?",
                        "type": "radio",
                        "options": [
                            { "label": "Yes" },
                            { "label": "No" },
                            { "label": "Not sure" }
                        ]
                    },
                    {
                        "number": 6,
                        "question": "Have you ever used self-storage?",
                        "type": "radio",
                        "options": [
                            { "label": "Yes" },
                            { "label": "No" },
                            { "label": "Not sure" }
                        ]
                    },
                    {
                        "number": 7,
                        "question": "Would you be interested in taking self-storage space at Safestore's new facility in Norbiton?",
                        "type": "radio",
                        "options": [
                            { "label": "Yes" },
                            { "label": "No" },
                            { "label": "Not sure" }
                        ]
                    },
                    {
                        "number": 8,
                        "question": "How do you typically travel to and from Norbiton?",
                        "type": "checkbox",
                        "options": [
                            { "label": "On foot" },
                            { "label": "By bike" },
                            { "label": "By car" },
                            { "label": "On public transport" },
                            { "label": "Other (please specify)" }
                        ]
                    }
                ],
                "key": "04-section"
            }
        ]
    },

    downloads: [
        {
            "title": "Download 1",
            "url": "#"
        },
        {
            "title": "Download 2",
            "url": "#"
        },
        {
            "title": "Download 3",
            "url": "#"
        }
    ],

    faqs: [
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
        {
            "question": "Lorem ipsum dolor",
            sections: [
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                },
                {
                    "text": "Proin felis felis, mattis in viverra non, dapibus eu arcu. Aliquam sed quam dictum, semper urna et, feugiat enim."
                }
            ]
        },
    ],

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? '[STAGING LINK]' : '[PROD LINK]',

    // Bugsnag API Key
    bugsnagApiKey: 'b261699c03a0ae1f2e637eb2fe02f5e5',

    // Marker.io Key - replace this default key
    marker_io: '65bbb950e456223248e60e82',

    // Cookiefirst ID
    cookieFirst: 'safestorenorbiton.co.uk-5d71730a-3464-4a96-9de2-15ce7f43d69c'
};
